import clsx from 'clsx';

import type { Adaptive } from '../types/Adaptive';
import type { FontWeight } from '../types/FontWeight';

export function composeFontWeightClasses(weight: Adaptive<FontWeight>): string {
    if (typeof weight === 'object') {
        return clsx(
            weight.base && `font-${weight.base}`,
            weight.sm && `sm:font-${weight.sm}`,
            weight.md && `md:font-${weight.md}`,
            weight.lg && `lg:font-${weight.lg}`,
            weight.xl && `xl:font-${weight.xl}`,
            weight['2xl'] && `2xl:font-${weight['2xl']}`
        );
    }

    return `font-${weight}`;
}
